import * as fromDatatype from '../datatype-library/index';

export interface bl_pgw_merchant_rate_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  template_guid: fromDatatype.GuidDataFieldInterface;
  contract_rate_guid: fromDatatype.GuidDataFieldInterface;
  rate_card_guid: fromDatatype.GuidDataFieldInterface;
  rate_card_line_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  rate: fromDatatype.NumericDatatypeInterface;
  rate_logic: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_pgw_merchant_rate_hdr_RowClass implements bl_pgw_merchant_rate_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  template_guid: fromDatatype.GuidDataFieldInterface;
  contract_rate_guid: fromDatatype.GuidDataFieldInterface;
  rate_card_guid: fromDatatype.GuidDataFieldInterface;
  rate_card_line_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  rate: fromDatatype.NumericDatatypeInterface;
  rate_logic: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
}
